import API from "../../Api";
import { Cart } from "./cartModels";
import { encryptJson } from "../../utils/react-ec-utils";

export function placeOrder(cartData: Cart) {
  const data = encryptJson(cartData);

  return API({
    method: "post",
    url: "/api/customers/order/createOrder",
    
    data: { data: data },
  });
}

export function cartItem(data: any){
    return API({
        method: "post",
        url: "/api/customers/order/cartItems",
        data: data
    })
}

